/* eslint-disable no-dupe-keys */
// import _ from 'lodash'
// import store from '@/store'

export default function buildFilter(filters) {
  let activeFilters = [];

  for (const filter in filters.bool) {
    if (filters.bool.hasOwnProperty(filter) && filters.bool[filter]) {
      activeFilters.push(filter);
    }
  }

  if (filters.eliteReferral) {
    activeFilters.push('referrer.elite');
  }

  if (filters.referral) {
    activeFilters.push('referral');
  }

  if (filters.notReferral) {
    activeFilters.push('!referral');
  }

  if (filters.questionsComplete) {
    activeFilters.push('questionsCompleted');
  }

  if (filters.questionsIncomplete) {
    activeFilters.push('!questionsCompleted');
  }

  if (filters.noEnquiries) {
    activeFilters.push('!hasEnquiries');
  }

  if (filters.ownerNotAssigned) {
    activeFilters.push('!owner.assigned');
  }

  if (filters.open) {
    activeFilters.push('!closed');
  }

  if (filters.noEmail) {
    activeFilters.push('noEmail');
  }
  if (filters.withEmail) {
    activeFilters.push('!noEmail');
  }
  if (filters.withPhone) {
    activeFilters.push('!noPhone');
  }
  if (filters.noPhone) {
    activeFilters.push('noPhone');
  }
  if (filters.autoSendEnquiries) {
    activeFilters.push('auto_send_enquiries');
  }
  if (filters.notAutoSendEnquiries) {
    activeFilters.push('!auto_send_enquiries');
  }

  return activeFilters;
}
